<div class="sign-up-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div
        class="daxa-form ml-auto mr-auto border-radius bg-white"
        [class.card-borderd-theme]="themeService.isCardBorder()"
        [class.component-dark-theme]="themeService.isDark()"
        [class.rtl-enabled]="themeService.isRTLEnabled()"
        >
        <div class="title text-center">
          <h3>
            Registracija
          </h3>
          <p class="text-black">
            Već imate korisnički račun? <a routerLink="/authentication" class="text-daxa">Prijava</a>
          </p>
        </div>
        <form [formGroup]="signupForm" (submit)="onSubmit()">

          <!-- Step 1: Personal Info -->
          <div formGroupName="personalInfo">
            <div class="form-group">
              <label class="main-label d-block lh-1 text-black">Ime odgovorne osobe</label>
              <mat-form-field>
                <mat-label>Unesite ime odgovorne osobe</mat-label>
                <input matInput formControlName="firstName">
              </mat-form-field>
              @if (signupForm.get('personalInfo.firstName')?.hasError('required') && signupForm.get('personalInfo.firstName')?.touched) {
                <div class="error text-danger">
                  Ime odgovorne osobe je obavezno polje.
                </div>
              }
            </div>
            <div class="form-group">
              <label class="main-label d-block lh-1 text-black">Prezime odgovorne osobe</label>
              <mat-form-field>
                <mat-label>Unesite prezime odgovorne osobe</mat-label>
                <input matInput formControlName="lastName">
              </mat-form-field>
              @if (signupForm.get('personalInfo.lastName')?.hasError('required') && signupForm.get('personalInfo.lastName')?.touched) {
                <div class="error text-danger">
                  Prezime odgovorne osobe je obavezno polje.
                </div>
              }
            </div>
          </div>

          <!-- Step 2: Općina odabir -->
          <div class="form-group">
            <label class="main-label d-block lh-1 text-black">Odaberite općinu kojoj pripadate</label>
            <mat-form-field>
              <mat-label>Općina</mat-label>
              <mat-select formControlName="municipalityId">
                @for (municipality of municipalities; track municipality) {
                  <mat-option [value]="municipality.id">
                    {{ municipality.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>


          <!-- Step 3: Detalji registracije (Email & Password) -->
          <div formGroupName="registrationDetails">
            <div class="form-group">
              <label class="main-label d-block lh-1 text-black">Email adresa</label>
              <mat-form-field>
                <mat-label>Unesite adresu elektroničke pošte</mat-label>
                <input matInput formControlName="email">
              </mat-form-field>
              @if (signupForm.get('registrationDetails.email')?.hasError('required') && signupForm.get('registrationDetails.email')?.touched) {
                <div class="error text-danger">
                  Email adresa je obavezno polje.
                </div>
              }
              @if (signupForm.get('registrationDetails.email')?.hasError('email') && signupForm.get('registrationDetails.email')?.touched) {
                <div class="error text-danger">
                  Molimo unesite valjanu adresu elektroničke pošte.
                </div>
              }
            </div>
            <div class="form-group">
              <label class="main-label d-block lh-1 text-black">Vaša lozinka</label>
              <mat-form-field>
                <mat-label>Unesite lozinku</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="password">
                <button mat-icon-button matSuffix (click)="hide = !hide">
                  <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </mat-form-field>
              @if (signupForm.get('registrationDetails.password')?.hasError('required') && signupForm.get('registrationDetails.password')?.touched) {
                <div class="error text-danger">
                  Lozinka je obavezno polje.
                </div>
              }
              @if (signupForm.get('registrationDetails.password')?.hasError('minlength') && signupForm.get('registrationDetails.password')?.touched) {
                <div class="error text-danger">
                  Lozinka mora biti duga najmanje 8 znakova.
                </div>
              }
            </div>
          </div>

          <div>
            <button mat-flat-button color="primary" type="submit">Registracija</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>